import * as React from 'react';
import { Row } from 'react-bootstrap';
import { compose } from 'redux';
import type { InjectedFormProps } from 'redux-form';
import { Field, reduxForm, destroy } from 'redux-form';

import type * as CustomerSignatureRequestModel from 'ab-requestModels/signature.requestModel';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import { SIGNATURE_FIELD_REPORT } from 'af-constants/reduxForms';

import { Button } from '@acceligentllc/storybook';

import Signature from 'af-fields/Signature';

import CustomModal from 'af-components/CustomModal';
import SubmitButton from 'af-components/SubmitButton';

interface OwnProps {
	closeModal: () => void;
	onSubmit: (form: CustomerSignatureRequestModel.SignatureForm) => Promise<void>;
	showModal: boolean;
}

type Props = OwnProps & InjectedFormProps<CustomerSignatureRequestModel.SignatureForm, OwnProps>;

const SignatureModal: React.FC<Props> = (props: Props) => {
	const {
		closeModal,
		handleSubmit,
		onSubmit,
		showModal,
		initialValues,
		initialize,
	} = props;

	React.useEffect(() => {
		if (showModal) {
			initialize(initialValues);
		} else {
			destroy();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showModal]);

	const submit = React.useCallback(async (form: CustomerSignatureRequestModel.SignatureForm) => {
		if (!form.signatureImage) {
			return;
		}

		const data: CustomerSignatureRequestModel.SignatureForm = {
			...form,
			signedAt: TimeUtils.formatDate(new Date(), TimeFormat.ISO_DATETIME),
		};

		await onSubmit(data);
		closeModal();
	}, [closeModal, onSubmit]);

	return (
		<CustomModal
			closeModal={closeModal}
			modalStyle="info"
			showModal={showModal}
			size="md"
		>
			<CustomModal.Header
				closeModal={closeModal}
				title="Sign"
			/>
			<CustomModal.Body>
				<Row className="row--padded-bottom">
					Use a stylus or a mouse to sign:
				</Row>
				<Row>
					<Field
						component={Signature}
						name="signatureName"
					/>
				</Row>
			</CustomModal.Body>
			<CustomModal.Footer>
				<Button
					label="Cancel"
					onClick={closeModal}
					style="secondary"
				/>
				<SubmitButton
					label="Sign & Submit"
					onClick={handleSubmit(submit)}
				/>
			</CustomModal.Footer>
		</CustomModal>
	);
};

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	reduxForm<CustomerSignatureRequestModel.SignatureForm, OwnProps>({ form: SIGNATURE_FIELD_REPORT })
);

export default enhance(SignatureModal);
